import PropTypes from 'prop-types';

import { useAuth } from 'context/AuthContext';

import Cookies from 'js-cookie';
import styles from './avatar.module.scss';

/**
 *   AVATAR COMPONENT
 *   @description It's the common component used for user profic picture
 */

export function Avatar({ src, className = '', isBig, isLarge }) {
  let BigAvatarClass = '';

  let BigSize = 30;

  const { userData } = useAuth();

  const URL = userData?.profilePic || src;

  const userInfo = JSON.parse(localStorage.getItem('userData'));

  let Name = userInfo?.email || Cookies.get('email');

  Name = Name?.slice(0, 1);

  if (isBig) {
    BigAvatarClass = styles.Big;
    BigSize = 40;
  } else if (isLarge) {
    BigSize = 100;
    BigAvatarClass = styles.Large;
  }

  return (
    <div className={`${styles.Avatar_Wrapper} ${className} `}>
      {URL ? (
        <img src={URL} width={BigSize} height={BigSize} alt="User profile" />
      ) : (
        <div className={`${styles.Avatar} ${BigAvatarClass}`}>{Name}</div>
      )}
    </div>
  );
}

Avatar.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  isBig: PropTypes.bool,
  isLarge: PropTypes.bool
};

Avatar.defaultProps = {
  src: '',
  className: '',
  isBig: false,
  isLarge: false
};
